import { createElement } from 'react';

import type { IconProps } from '../icon/icon';
import { Icon } from '../icon/icon'; // props is just passed in to keep variables.jsx happy. We don’t use variables.props
const SvgTickIcon = (componentProps: IconProps, props = {}) => {
  return createElement(
    Icon,
    componentProps,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M20.03 7.28 9.143 18.17 4.1 13.127l1.061-1.06 3.98 3.98L18.97 6.22z"
        clipRule="evenodd"
      />
    </svg>,
  );
};
export default SvgTickIcon;
